import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const navigate = useNavigate();

  const validateEmail = (value) => {
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return pattern.test(value);
    };

  const handleLogin = async (e) => {
    e.preventDefault();

    setEmailError("");
    setPasswordError("");

    let valid = true;

    if (!validateEmail(email)) {
        setEmailError("Please enter a valid email address.");
        valid = false;
    }

    if (!password.trim()) {
        setPasswordError("Password is required.");
        valid = false;
    }

    if (!valid) return;

    const res = await fetch("/amz-api/account/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    if(res.ok){
      const data = await res.json();
      localStorage.setItem("token", data.token);
      localStorage.setItem('dbuid', data.dbuid);      
      localStorage.setItem("accountOptions", JSON.stringify(data.accounts));
      localStorage.setItem("marketplaceOptions", JSON.stringify(data.marketplaces));

      navigate("/");
      window.location.reload();
    } else {
      alert("Login failed");
    }
  };

  return (
    <div className="container main-container h-100 flex-grow-1">
      <div className="row mt-5">
      <div className="col d-flex justify-content-center align-items-center">
        <form onSubmit={handleLogin} className="form-login bg-white border border-secondary-subtle shadow-sm">
          <h2 className="mb-3 p-3 bg-secondary text-white fs-6 form-header">Login</h2>
          <div className="mb-3 px-3">
              <label htmlFor="inputEmail" className="form-label">Email address</label>
              <input id="inputEmail" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" autoComplete="email" />
               {emailError && <div style={{ color: "red" }}>{emailError}</div>}
          </div>
          <div className="px-3">
              <label htmlFor="inputPassword" className="form-label">Password</label>
              <input id="inputPassword" className="form-control" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" autoComplete="current-password" />
              {passwordError && <div style={{ color: "red" }}>{passwordError}</div>}
          </div>
          <div className="p-3">
            <button type="submit" className="btn btn-primary">Login</button>
          </div>
        </form>
      </div>
      </div>
    </div>
  );
}
export default Login;
